import { j as t } from "./atoms-v218.js";
import { AdditionalRatesAndPackages as o } from "./atoms-v2116.js";
import { OtherPaymentMethods as r } from "./atoms-v2117.js";
import { PaymentHeader as s } from "./atoms-v2118.js";
import { PriceBreakdown as m } from "./atoms-v2119.js";
import { RateDetails as a } from "./atoms-v2120.js";
import { SecurityCode as c } from "./atoms-v2121.js";
const e = () => /* @__PURE__ */ t.jsx("div", { children: "The Checkout components should not be referenced directly. Please use the Checkout namespace to access its components (e.g. <Checkout.OtherPaymentMethods />)." });
e.displayName = "Checkout";
const f = Object.assign(e, {
  AdditionalRatesAndPackages: o,
  OtherPaymentMethods: r,
  PaymentHeader: s,
  PriceBreakdown: m,
  RateDetails: a,
  SecurityCode: c
});
export {
  f as Checkout
};
